import React from 'react';
import { Helmet } from "react-helmet-async";
import Aux from '../../../hoc/Auxiliary/Auxiliary';
import SlickCarousel from '../../../containers/Galery/Carousel/SlickCarousel/SlickCarousel';
import classes from './Recipe.module.css';

const recipeDetail = (props) => {
	let attachClasses = [classes.IngredientsList];
	if (props.isDetailPage) {
		attachClasses = [classes.IngredientsDetail];
	}

	const { data, isDetailPage, isLandingPage, listingRecipes, className } = props;
	if (!data) return null;

	const canonicalUrl = data.slug
		? `https://sweetorsalted.com/recipes/${data.type}/${data.slug}`
		: null;

	const baseImageUrl = 'https://images.sweetorsalted.com/';
	const sections = [];

	// TITLE
	if (data.title) {
		sections.push(
			<h1 key="title" className={`${classes.Title} ${className || ''}`}>
				{data.title} - {data.title_context}
			</h1>
		);
	}

	// DESCRIPTION (ONLY DETAIL PAGE)
	if (isDetailPage && data.intro) {
		sections.push(
			<div key="intro" className={classes.Intro}>
				<div className={classes.DescriptionTitle}>
					<div className={classes.DescriptionTitle}>
						{(data.intro || '')
							.split(/\\n|\n/)
							.filter(line => line.trim() !== '')
							.map((line, i) => (
								<p key={i}>{line}</p>
							))
						}
            		</div>
				</div>
			</div>
		);
	}

	if (isDetailPage && Array.isArray(data.images) && data.images.length > 0) {
		sections.push(
			<div key="image" className={classes.PrimaryImageWrapper}>
				<img src={baseImageUrl + data.images[data.images.length - 1]} alt={data.title} />
			</div>
		);
	}

	// INGREDIENTS (ONLY DETAIL PAGE)
	if (isDetailPage && Array.isArray(data.ingredients)) {
		const ingList = data.ingredients.map((item, i) => {
		if (listingRecipes && i >= 5) return null;

		return (
			<li key={i} className={classes.IngredientItem}>
				<label className={classes.IngredientLabel}>
					<input type="checkbox" className={classes.IngredientCheckbox} />
					<span>{item}</span>
				</label>
			</li>
		);
		});

		sections.push(
			<div key="ingredients" className={classes.IngredientsListWrapper}>
				<h2 className={classes.SectionTitle}>Необходими продукти</h2>
				<ul className={attachClasses.join(' ')}>
				{ingList}
				</ul>
			</div>
		);
	}

	// DESCRIPTION (ONLY DETAIL PAGE)
	if (isDetailPage && data.description) {
		sections.push(
		<Aux>
			<h2 className={classes.SectionTitle}>Начин на приготвяне</h2>
			<div key="description" className={classes.RecipeDescription}>
				{(data.description || '')
					.split(/\\n|\n/)
					.filter(line => line.trim() !== '') // to remove the last empty ""
					.map((line, i) => (
						<p key={i} className={classes.Step}>
							<span className={classes.StepNumber}>{i + 1}.</span>
							{line}
						</p>
					))
				}
			</div>
		</Aux>
		);
	}

	if (isDetailPage && data.tips) {
		sections.push(
			<Aux>
				<h2 className={classes.SectionTitle}>Съвети</h2>
				<div key="tips" className={classes.Intro}>
					<div className={classes.DescriptionTitle}>
						<div className={classes.DescriptionTitle}>
							{(data.tips || '')
								.split(/\\n|\n/)
								.filter(line => line.trim() !== '')
								.map((line, i) => (
									<p key={i}>
										<span className={classes.StepNumberTips}></span>
										{line}
									</p>
								))
							}
						</div>
					</div>
				</div>
			</Aux>
		);
	}

	// IMAGES PART 2
	if (Array.isArray(data.images) && data.images.length > 0) {
		sections.push(
		isDetailPage || isLandingPage
			? <SlickCarousel key="carousel" images={data.images} variant="CarouselImageWrapperPdp" />
			: (
			<div key="image" className={classes.RecipeImagesWrapper}>
				<img src={baseImageUrl + data.images[0]} alt={data.title} />
			</div>
			)
		);
	}

  	return <>
			<Helmet>
				{/* ✅ Title */}
				<title>
					{data.title} – {data.title_context || 'лесна рецепта'} | Сладко или Солено
				</title>

				{/* ✅ Meta Description */}
				<meta
					name="description"
					content={`Рецепта за ${data.title.toLowerCase()} – ${
						data.title_context || 'лесна домашна рецепта'
					}. Вижте съставките и стъпките за приготвяне.`}
				/>

				{/* ✅ Canonical */}
				{canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

				{/* ✅ Open Graph */}
				<meta property="og:title" content={data.title} />
				<meta
					property="og:description"
					content={`Рецепта за ${data.title.toLowerCase()} – ${
						data.title_context || 'лесна рецепта'
				}.`}
				/>
				<meta property="og:url" content={canonicalUrl} />

				{data.images?.length > 0 && (
				<meta
					property="og:image"
					content={baseImageUrl + data.images[0]}
				/>
				)}

				{/* ✅ Schema */}
				<script type="application/ld+json">
				{JSON.stringify({
					"@context": "https://schema.org",
					"@type": "Recipe",
					name: data.title,
					image: data.images?.map(img => baseImageUrl + img),
					recipeCategory: data.type,
					recipeIngredient: data.ingredients,
					recipeInstructions: data.description
					?.split(/\\n|\n/)
					.map(step => ({
						"@type": "HowToStep",
						text: step
					}))
				})}
				</script>
			</Helmet>
		{sections}
	</>
};


export default recipeDetail;
